// eslint-disable-next-line
import React from 'react';

import '../css/settings.css';

import { AppContext } from '../AppContext';
import { SearchOption } from '../data/Search';
import Container from '../basicComponents/Container';
import Text from '../basicComponents/Text';
import CheckBox from '../basicComponents/CheckBox';
import Select from '../basicComponents/Select';
import InputText from '../basicComponents/InputText';

export interface SettingsPageProps { 

    searchRange: string;
    searchLimit: number;
    logSearchLimit: number;
    searchOptions: SearchOption[];

    setSearchRange: (searchRange: string) => void;
    setSearchLimit: (searchLimit: number) => void;
    setLogSearchLimit: (logSearchLimit: number) => void;
    searchOptionChanged: (event: React.ChangeEvent<HTMLInputElement>) => void;

}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface SettingsPageState { 
}

export default class SettingsPage extends React.Component<SettingsPageProps, SettingsPageState> {

    // context
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;

    private iconNever: JSX.Element = <i className="fas fa-minus settings-value settings-never"></i>;
    private iconAlways: JSX.Element = <i className="fas fa-check settings-value settings-always"></i>;

    private ranges = [ 'today', 'yesterday', 'one week', 'two weeks' ];

    public render(): JSX.Element {

        return (
            <Container className='settings-page'>
                <Container className='settings-section'>
                    <Text className='settings-label'>default range</Text>
                    <Select className='settings-value-left' name='defaultRange' value={this.props.searchRange} options={this.ranges} onChange={this.handleSelect} />
                    <Text className='settings-label'>result limit per server</Text>
                    <InputText className='settings-value-left' name='searchLimit' value={this.props.searchLimit.toString()} onChange={this.handleChange} />
                    <Text className='settings-label'>result log limit per server</Text>
                    <InputText className='settings-value-left' name='logSearchLimit' value={this.props.logSearchLimit.toString()} onChange={this.handleChange} />
                </Container>
                <Container className='settings-list'>
                    <Text className='settings-header'>Field</Text>
                    <Text className='settings-header'>View</Text>
                    <Text className='settings-header'>Search</Text>
                    {this.props.searchOptions.map( (searchOption, idx) => {
                        return (
                            <React.Fragment key={idx}>
                                <Text className='settings-label'>{searchOption.displayName}</Text>
                                {searchOption.viewOption === 'Q' ?
                                    <CheckBox className='settings-value' name={'v_' + searchOption.databaseName} checked={searchOption.viewActive} onChange={this.props.searchOptionChanged} />
                                    :
                                    searchOption.viewOption === 'N' ? this.iconNever : this.iconAlways 
                                }
                                {searchOption.searchOption === 'Q' ?
                                    <CheckBox className='settings-value' name={'s_' + searchOption.databaseName} checked={searchOption.searchActive} onChange={this.props.searchOptionChanged} />
                                    :
                                    searchOption.searchOption === 'N' ? this.iconNever : this.iconAlways
                                }
                            </React.Fragment>
                        );
                    })}
                </Container>
            </Container>
        );

    }

    private handleSelect = (event: React.ChangeEvent<HTMLSelectElement>): void => {

        const target = event.currentTarget;
        const value = target.value;

        this.props.setSearchRange(value);

        // store in user settings
		this.context.user.setUserSetting('SymQuery', 'searchRange', value);

    }

    private handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {

        const target = event.currentTarget;
        const name = target.name;
        const value = target.value;

        switch (name) {

            case 'searchLimit':
                {

                    const limit = Number.parseInt(value);
                    this.props.setSearchLimit(Number.isNaN(limit) ? 0 : limit);
            
                    // store in user settings
                    this.context.user.setUserSetting('SymQuery', 'searchLimit', (Number.isNaN(limit) ? 0 : limit).toString() );
                    
                }
                break;

                case 'logSearchLimit':
                    {
    
                        const limit = Number.parseInt(value);
                        this.props.setLogSearchLimit(Number.isNaN(limit) ? 0 : limit);
                
                        // store in user settings
                        this.context.user.setUserSetting('SymQuery', 'logSearchLimit', (Number.isNaN(limit) ? 0 : limit).toString() );
                        
                    }
                    break;
    
        }

    }

}
